export const onFrenchConsent = (QuebecRedirectionConstants) => {
  sessionStorage.setItem(
    QuebecRedirectionConstants.userLanguageChoice,
    QuebecRedirectionConstants.fr_ca
  );
  window.location.href = `/${QuebecRedirectionConstants.fr_ca}`;
};

export const handleQuebecRedirection = (
  QuebecRedirectionConstants,
) => {
  const userChoice = sessionStorage.getItem(
    QuebecRedirectionConstants.userLanguageChoice
  );
  const currentPath = window.location.pathname;

  const redirectToLanguage = (language) => {
    window.location.href = `/${language}`;
  };

  const handleGeoLocationSuccess = ({ coords: { latitude, longitude } }) => {
    const isWithinRegion =
      latitude >= process.env.LATITUDE_LOWER_LIMIT &&
      latitude <= process.env.LATITUDE_UPPER_LIMIT &&
      longitude >= process.env.LONGITUDE_LOWER_LIMIT &&
      longitude <= process.env.LONGITUDE_UPPER_LIMIT;
    const isEnglishPath = currentPath.includes(
      `/${QuebecRedirectionConstants.en_ca}`
    );

    if (!userChoice && isEnglishPath && isWithinRegion) {
      onFrenchConsent(QuebecRedirectionConstants);
    }
  };

  const handleGeoLocationError = (error) => {
    console.error('Location Service Not Allowed', error);
  };

  if (!currentPath.includes(`/${QuebecRedirectionConstants.fr_ca}`)) {
    if (!userChoice) {
      navigator.geolocation?.getCurrentPosition(
        handleGeoLocationSuccess,
        handleGeoLocationError
      );
    } else if (
      userChoice === QuebecRedirectionConstants.fr_ca &&
      currentPath.includes(`/${QuebecRedirectionConstants.en_ca}`)
    ) {
      redirectToLanguage(QuebecRedirectionConstants.fr_ca);
    }
  }
};
